import { Box, SxProps, Theme } from "@mui/material";

interface TextButtonProps {
  children: React.JSX.Element | React.JSX.Element[];
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

const TextButton = (props: TextButtonProps): React.JSX.Element => {
  const { children, onClick, sx } = props;

  return (
    <Box
      sx={{
        textDecoration: "none",
        color: "secondary.dark",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        ...sx,
      }}
      onClick={onClick}
    >
      {children}
    </Box>
  );
};

export default TextButton;
